// extracted by mini-css-extract-plugin
module.exports = {"iconCircle":"Selection_iconCircle__3XjdV","wrap":"Selection_wrap__33psC","item":"Selection_item__2JDcH"};